import React from "react";
import QurealRichEditor from "./QurealRichEditor";

const QurealStandardEditor = (props) => {
    return (
        <QurealRichEditor
            {...props}
            editorOptions={{
                includeTable: true,
                includeMedia: true,
                includeFormatting: true,
                includeAlignment: true,
            }}
            menuFeatures="all"
            menuType="fixed"
        />
    );
};

export default QurealStandardEditor;
